import React, { useState, useEffect, useContext } from "react";
import { SettingsContext } from "../providers/SettingsProvider";
import { processReminder } from "../helperFunctions/dateFormatters";
import Close from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import "../css/notifications.scss";

const Notifications = () => {
  const { businessInfo } = useContext(SettingsContext);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // Show notifications for business info reminders
    if (businessInfo.length > 0) {
      let newNotifications = [];

      businessInfo.forEach((info) => {
        if (info.category === "reminder") {
          if (info.value) {
            let reminderNote = processReminder(info);

            if (
              (reminderNote.warning || reminderNote.expired) &&
              reminderNote.show
            ) {
              /*
              Break up processing the notification, so that we can use the date stuff on the
              businessInfo page to show which ones are expired.

              Will need to figure out a way to show the notifications, as well as a way to
              dismiss them.
              */
              newNotifications.push(reminderNote);
            }
          }
        }
      });

      setNotifications(newNotifications);
    } else {
      setNotifications([]);
    }
  }, [businessInfo]);

  function handleDismiss(e) {
    // let el = e.currentTarget.parentNode;
    let uid = e.currentTarget.parentNode.dataset.uid;

    let newNotifications = notifications.filter((n) => n.uid !== uid);
    setNotifications(newNotifications);
  }

  return (
    <div className="notifications-container">
      {notifications.map((n, i) => {
        let { warning, expired, text, title, uid } = n;
        let noteClass = "";
        if (warning) {
          noteClass = "warningNote";
        }
        if (expired) {
          noteClass = "expiredNote";
        }

        let offset = (i + 1) * 53;

        return (
          <div
            data-uid={uid}
            className={`notification ${noteClass}`}
            style={{ bottom: `${offset}px` }}
            key={uid}
          >
            <p>
              <Link
                replace={false}
                to={{
                  pathname: `/settings/business-information`,
                }}
              >
                {title} : {text}
              </Link>
            </p>
            <button onClick={handleDismiss} className="linkToSettings">
              <Close />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default Notifications;
